import React from 'react'
import { DataGrid, GridId, GridAutoSizing } from 'view/components/datagrid'
import { tradingEntityAliasesGridOptions, tradingEntityAliasesColumnDefs } from './TradingEntityAliasesGridModel'
import { organisationAliasesDetailSelector } from 'selectors/tradingEntitySelectors/tradingEntityAliasesSelectors'
import { useSelector } from 'react-redux'

export const TradingEntityAliasesGrid = () => {
  const organisationAliasesDetails = useSelector(organisationAliasesDetailSelector)

  return (
    <DataGrid
      gridId={GridId.TradingEntityAliasesGrid}
      gridOptions={tradingEntityAliasesGridOptions}
      gridColumnAutoSizing={GridAutoSizing.NONE}
      columnDefs={tradingEntityAliasesColumnDefs}
      rowData={organisationAliasesDetails}
      disableGrouping={true}
    />
  )
}
